module.exports = __webpack_public_path__ + "img/icon_flash_white.c33693fe.svg";